import React from 'react';
import { BackPage, Spinner, OrdersReminder } from 'components';
import { useOrderById } from 'hooks';
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styles from './styles.module.css';

const CreateOrderReminder = () => {
  const history = useHistory();
  let { id } = useParams();

  const [order, getOrderById] = useOrderById();

  useEffect(() => {
    getOrderById(id);
  }, [getOrderById, id]);

  if (!order) {
    return (
      <BackPage onBackClick={() => history.goBack()} bplg="10">
        <div className={styles.loadingSpinner}>
          <Spinner />
        </div>
      </BackPage>
    );
  }
  return (
    <BackPage onBackClick={() => history.goBack()} bplg="10">
      <div className="coop-l-container">
        <h1 className={styles.pageHeader}>Medication requested</h1>
        <div className={styles.wrapper}>
          {order?.order_items.map((item) => {
            return (
              <div className={styles.container}>
                <h2 className={styles.header}>{item.name}</h2>
                <p>{item?.instructions?.slice(0, item?.instructions?.search(/(\r\n|\r|\n)/g))}</p>
              </div>
            );
          })}

          <OrdersReminder
            orderId={order?.order_id}
            redirectFn={() => history.push(`/pharmacy/dashboard/order/${order?.order_id}`)}
            submitText="Save"
          />
        </div>
      </div>
    </BackPage>
  );
};

export default CreateOrderReminder;
